import ClubFee from './ClubFee';

export default class ClubDunningLevel {
    constructor() {
        this.id = null;
        this.paymentDeadline = null;
        this.clubFee = null;
        this.level = null;
        this.pdfText = null;
        this.pdfTextFooter = null;
        this.showBankDetails = null;
        this.enabled = false;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        const clubDunningLevel = new ClubDunningLevel();
        clubDunningLevel.id = data.id;
        clubDunningLevel.paymentDeadline = data.paymentDeadline;
        clubDunningLevel.clubFee = null;
        if (data.clubFeeId !== null) {
            clubDunningLevel.clubFee = ClubFee.fromData({ id: data.clubFeeId, priceHistory: null });
        }
        clubDunningLevel.level = data.level;
        clubDunningLevel.pdfText = data.pdfText;
        clubDunningLevel.pdfTextFooter = data.pdfTextFooter;
        clubDunningLevel.showBankDetails = data.showBankDetails;
        clubDunningLevel.enabled = data.enabled;

        return clubDunningLevel;
    }

    serialize() {
        return {
            id: this.id,
            paymentDeadline: this.paymentDeadline !== null && this.paymentDeadline !== '' ? Number(this.paymentDeadline) : null,
            clubFeeId: this.clubFee !== null ? this.clubFee.id : null,
            level: this.level,
            pdfText: this.pdfText,
            pdfTextFooter: this.pdfTextFooter,
            showBankDetails: this.showBankDetails,
            enabled: this.enabled,
        };
    }
}
